import { useLocationInfo } from 'context/location'

// The business at the top of the sidebar: its logo tile and name (studio shell style).
function AppLogo() {
  const { location } = useLocationInfo()
  const name = location?.name || location?.basic_info?.name || 'Location'
  const logo = location?.basic_info?.logo

  return (
    <a href='/' className='flex items-center gap-3 min-w-0 rounded-control focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-focus'>
      <span className='flex w-9 h-9 shrink-0 items-center justify-center overflow-hidden rounded-[10px] border border-line bg-soft text-sm font-bold text-ink'>
        {logo ? <img src={logo} className='w-full h-full object-cover' alt='' /> : name.slice(0, 1).toUpperCase()}
      </span>
      <span className='min-w-0 text-[13px] font-bold text-ink truncate' title={name}>
        {name}
      </span>
    </a>
  )
}

export default AppLogo
